import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	remoteLinkGeneralErrorIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	remoteLinkGeneralError: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	// Copy for linked work items error row
	linkedWorkItemAuthRequiredCta: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	// Combined text + CTA with placeholder for proper spacing/i18n handling
	linkedWorkItemAuthRequiredWithCta: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	linkedWorkItemMissingApplinkCta: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	// Combined text + CTA with placeholder for proper spacing/i18n handling
	linkedWorkItemMissingApplinkWithCta: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	remoteLinkGeneralErrorIssueTermRefresh: {
		id: 'issues.issue-links.remote-issue-link-error.general-error-issue-term-refresh',
		defaultMessage: 'Failed to load work item',
		description: 'General error message for remote issue link',
	},

	remoteLinkGeneralError: {
		id: 'issues.issue-links.remote-issue-link-error.general-error',
		defaultMessage: 'Failed to load remote issue',
		description: 'General error message for remote issue link',
	},

	// Copy for linked work items error row
	linkedWorkItemAuthRequiredCta: {
		id: 'native-issue-table.remote-issue-error.linked-work-item-auth-required.cta',
		defaultMessage: 'Authenticate',
		description: 'CTA to authenticate to the separate Jira site',
	},
	// Combined text + CTA with placeholder for proper spacing/i18n handling
	linkedWorkItemAuthRequiredWithCta: {
		id: 'native-issue-table.remote-issue-error.linked-work-item-auth-required.with-cta',
		defaultMessage:
			"This linked work item belongs to a separate Jira site that's not authenticated. {cta}",
		description: 'Auth required message including CTA placeholder',
	},
	linkedWorkItemMissingApplinkCta: {
		id: 'native-issue-table.remote-issue-error.linked-work-item-missing-applink.cta',
		defaultMessage: 'Go to Project settings to link',
		description: 'CTA to navigate to project settings to link the site',
	},
	// Combined text + CTA with placeholder for proper spacing/i18n handling
	linkedWorkItemMissingApplinkWithCta: {
		id: 'native-issue-table.remote-issue-error.linked-work-item-missing-applink.with-cta',
		defaultMessage:
			'This linked work item belongs to a separate Jira site that’s not linked. {cta}',
		description: 'Missing applink message including CTA placeholder',
	},
});
export default messages;
